module.exports = __webpack_public_path__ + "static/images/fill-low.17d67a2a94837743c797e0d38492cef7.svg";